import baseApi from './baseApi'

export const aggregateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => ({
        url: `/get_all_category`,
      }),
      transformResponse: (data) => data.get_cat,
    }),
    getAggregate: builder.query({
      query: ({ id }) => ({
        method: 'POST',
        url: '/brain_scan_aggregate',
        body: { user_id: id },
      }),
      transformResponse: (data) => data.aggregate,
      providesTags: ['brain_report'],
    }),
    getAggregates: builder.query({
      query: ({ isGroup }) => ({
        method: 'POST',
        url: '/brain_scan_aggregate_all',
        body: { isGroup },
      }),
      transformResponse: (data) => {
        return Object.entries(data).map(([k, d]) => ({ name: k, chart: d.aggregate }))
      },
      providesTags: ['brain_report'],
    }),
  }),
  overrideExisting: false,
})

// auto-generated based on the defined endpoints
export const { useGetAggregateQuery, useGetAggregatesQuery, useGetCategoriesQuery } = aggregateApi
